import { FieldDetails } from '@openx/components-core/lib/FieldDetails/FieldDetails';
import { FormSection } from '@openx/components-core/lib/FormSection/FormSection';
import type { PackageFormState } from '@openx/types/package';
import { useTranslation } from 'react-i18next';
import { usePackageContext } from '../../../utils/context/PackageContext';

type OnBehalfOfProps = {
  pckg: PackageFormState;
};

export function OnBehalfOf({ pckg }: OnBehalfOfProps) {
  const { t } = useTranslation();
  const { useRelatedAccountsFetch } = usePackageContext();
  const { relatedAccounts = {}, loading: relatedAccountsLoading } = useRelatedAccountsFetch([pckg]);
  const name = relatedAccounts[pckg.account_uid]?.name;

  return (
    <FormSection divider title={t('On Behalf Of')}>
      <FieldDetails loading={relatedAccountsLoading} title={t('Account for Package')} value={name} />
    </FormSection>
  );
}
